export const getTicketDisponibility = (
  quantity_available,
  unlimited,
  sold_out,
  has_expired,
  limited,
) => {
  let text = '';

  if (quantity_available == 0) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.remaining.zero', {
      count: quantity_available,
    })}`;
  } else if (quantity_available == 1) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.remaining.one', {
      count: quantity_available,
    })}`;
  } else {
    text = ` — ${I18n.t('web.networks.events.tickets.list.remaining.other', {
      count: quantity_available,
    })}`;
  }

  if (has_expired) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.expired')}`;
  } else if (unlimited) {
    text = '';
  } else if (limited) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.limit_by_user')}`;
  } else if (sold_out) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.sold_out')}`;
  }

  return text;
};
